<template>
  <div class="footer_pot">
    <div class="footer_up" :style='footbgk'>
      <div class="footer_up_cup">
        <el-row>
          <el-col :span="8">
            <h3>友情链接</h3>
            <ul>
              <li v-for="(linker,index) in linkArr" :key="index">
                <el-link :href="linker.path" :underline="false" target="_blank" class="friends">{{linker.item}}</el-link>
              </li>
            </ul>
          </el-col>
          <el-col :span="8">
            <h3>联系我们</h3>
            <ul>
              <li v-for="(element,index) in contactArr" :key="index">
                <img :src="element.icon" alt />
                <span>{{element.item}}</span>
              </li>
            </ul>
          </el-col>
          <el-col :span="8">
            <div class="footer_pt">
              <el-row :gutter="20">
                <el-col :span="10">
                  <div class="pt_item">
                    <div @mouseenter="seePT(1)" class="third-android">
                      <img :src="appObj.path" alt />
                    </div>
                    <div class="pingtai_text">{{appObj.name}}</div>
                  </div>
                </el-col>
                <el-col :span="10">
                  <div class="pt_item">
                    <div @mouseenter="seePT(2)" class="third-android">
                      <img :src="weinxin.path" alt />
                    </div>
                    <div class="pingtai_text">{{weinxin.name}}</div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="footer_down">
      <div>
        <el-link href="#home" type="primary" :underline="false">{{new Date().getFullYear()}} © IAIC 版权所有&nbsp;&nbsp;</el-link>
        <span>&nbsp;|&nbsp;</span>
        <el-link target="_blank" type="primary" :underline="false" @click="goPrivacy">隐私政策</el-link>
        <span>&nbsp;|&nbsp;</span>
        <!-- <el-link :href="right.sale" target="_blank" type="primary" :underline="false">销售支持</el-link>
        <span>&nbsp;|&nbsp;</span> -->
        <el-link :href="right.law" target="_blank" type="primary" :underline="false">法律信息</el-link>
        <span>&nbsp;|&nbsp;</span>
        <el-link :href="right.vpn" target="_blank" type="primary" :underline="false">员工VPN客户端下载</el-link>
        <span>&nbsp;|&nbsp;</span>
        <el-link :href="right.IPNo" target="_blank" type="primary" :underline="false">豫ICP备 19000234号-1</el-link>
      </div>
      <div class="footer_space">
        <el-link :href="police.link" target="_blank" type="primary" :underline="false">
          <img :src="police.url" alt />
          <span>{{police.name}}</span>
        </el-link>
      </div>
    </div>
    <div class="show_codeImg" v-show="isCodePlay" @mouseout="hideAndroid">
      <el-card class="box-card">
        <img :src="android" alt width="150" height="150" />
      </el-card>
    </div>
    <div class="show_public" v-show="isWX" @mouseout="hidewx">
      <el-card class="box-card">
        <img :src="wxPublic" alt width="150" height="150" />
      </el-card>
    </div>
  </div>
</template>
<script>
import IMGSTATION from '../../../common/util/imgStation'
export default {
  data() {
    const footerParam = IMGSTATION.sysFoot
    return {
      contactArr: [
        {
          icon: IMGSTATION.footerModule.phone,
          item: '电话：0379-60199639'
        },
        {
          icon: IMGSTATION.footerModule.zipcode,
          item: '邮编：471934'
        },
        {
          icon: IMGSTATION.footerModule.email,
          item: '邮箱：lychiaic@chiaic.com'
        },
        {
          icon: IMGSTATION.footerModule.location,
          item: '地址：洛阳市伊滨区孝文大道18号'
        }
      ],
      linkArr: [
        {
          item: '中华人民共和国工业和信息化部',
          path: 'http://www.miit.gov.cn/'
        },
        {
          item: '中华人民共和国科学技术部',
          path: 'http://www.most.gov.cn/'
        },
        {
          item: '中华人民共和国农业农村部',
          path: 'http://www.moa.gov.cn/'
        },
        {
          item: '国家智能农机装备产业技术创新战略联盟',
          path: 'http://www.iamea.org.cn/'
        }
      ],
      weinxin: {
        name: '微信公众号',
        path: '../../../../static/img/footer/wenxin_1.png'
      },
      appObj: {
        name: '河南农机云公众号',
        path: '../../../../static/img/footer/gongzhonghao_small.png'
      },
      right: {
        IPNo: 'http://beian.miit.gov.cn',
        sale: 'http://xsfw.chiaic.com',
        law: '',
        vpn: 'https://vpn.chiaic.com:8443/portal/#/down_client_new',
      },
      police: {
        name: '豫公网安备 41031102000192 号',
        url: IMGSTATION.footerModule.police,
        link: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41031102000192'
      },
      isCodePlay: false,
      android: '../../../../static/img/footer/gongzhonghao.png',
      isWX: false,
      wxPublic: '../../../../static/img/footer/weixin.jpg',
      footbgk: `background-image: url(${footerParam});`
    };
  },
  watch: {
    // isCodePlay(val) {
    //   console.log('是否开启深度监听');
    //   window.addEventListener('click', () => {
    //   });
    // }
  },
  methods: {
    goPrivacy() {
      this.$router.push({ name: 'privacy' });
    },
    seePT(ptType) {
      switch (ptType) {
        case 1:
          this.isCodePlay = true;
          this.isWX = false;
          break;
        case 2:
          this.isCodePlay = false;
          this.isWX = true;
          break;
      }
    },
    hideAndroid() {
      this.isCodePlay = false;
    },
    hidewx() {
      this.isWX = false;
    }
  }
};
</script>
<style lang="stylus" scoped>
.footer_pot {
  min-height: 320px;
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: 5;

  ul {
    list-style-type: none;
    margin-left: -40px;
  }

  li {
    margin-top: 10px;
  }

  img {
    vertical-align: middle;
  }

  .footer_up {
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% auto;
    color: #fff;

    .footer_up_cup {
      width: 70%;
      margin: 0 auto;
      padding: 20px 0;
    }

    .footer_pt {
      text-align: center;
      width: 100%;
      height: 100%;

      .pt_item {
        margin-top: 31%;

        .third-android {
          width: 86px;
          height: 86px;
          border-radius: 43px;
          margin: 0 auto;
        }

        .pingtai_text {
          margin-top: 10px;
          font-size: 12px;
          color: #fff;
        }
      }
    }

    .friends {
      color: #fff;
    }
  }

  .footer_down {
    text-align: center;
    background-color: #fff;
    height: 80px;
    padding-top: 20px;

    .copy_right {
      color: #409EFF;
      font-size: 14px;
    }
  }

  .show_codeImg {
    position: absolute;
    bottom: 37%;
    right: 29%;
  }

  .show_public {
    position: absolute;
    bottom: 37%;
    right: 18%;
  }
}

.footer_space {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/footer/footer.vue